import React, { Component } from "react";
import {
  Select,
  Spin,
  Modal,
  Row,
  Col,
  Card,
  Tag,
  Tree,
  Input,
  Icon,
  Tabs,
  Button,
} from "antd";
// model
import Organization from "./model/organization";
import PersonItem from "../group-user-select/models/personItem";

// style
import "./style.less";
// service
import AppService from "../service/app.service";
const { Option } = Select;
const { TreeNode } = Tree;
const { TabPane } = Tabs;
interface iProps {
  url: string;
  tabs: any[];
  allowClear?: boolean;
  placeholder?: string;
  value?: any[];
  params?: any;
  disabled?: boolean;
  onChange?: (value: PersonItem[] | Organization[]) => void;
  children?: React.ReactNode;
}
export default class groupSubuctClassSelect extends Component<iProps> {
  private appService: AppService = new AppService();
  state = {
    loading: false,
    treeData: {},
    checkedIdsObj: {},
    tabs: [],
    visible: false,
    tabKey: "",
    expandedKeys: [],
    autoExpandParent: true,
    checkedOrganizationListObj: {},
    selectedKeysObj: {},
    selectedOrganizationObj: {},
    list: [],
  };
  handleNodes = (itemArr) => {
    itemArr.forEach((item, index) => {
      //1.给学科节点加上gradeId
      //2.给学科下面的班级的parantId 也加上届id
      if (item.organizationType === "SUBJECT") {
        item.id = `${item.id}-${item.parentId}`;
        if (item?.subItems && item?.subItems?.length > 0) {
          item.subItems = item.subItems.map((subItem) => {
            subItem.parentId = `${subItem.parentId}-${item.parentId}`;
            return subItem;
          });
        }
        return;
      } else {
        this.handleNodes(item.subItems);
      }
    });
    return itemArr;
  };
  handleReturnValue = (organizationNested) => {
    let newVal = this.handleNodes(organizationNested);

    return newVal;
  };
  getGroupClassSelectTabTree = async () => {
    let { url, params } = this.props;
    if (!this.state.treeData || JSON.stringify(this.state.treeData) === "{}") {
      for (let tab of this.props.tabs) {
        this.setState({ loading: true });
        let { organizationNested, organizationList } =
          await this.appService.getGroupClassSelectTabTree(url, {
            selectType: tab.key,
            ...params,
          });
        this.setState({ loading: false });
        organizationNested = this.handleReturnValue(organizationNested);
        await this.setState({
          treeData: {
            ...this.state.treeData,
            [tab.key]: { organizationNested, organizationList },
          },
        });
      }
    }
  };
  renderTreeNodes = (organizationList: Organization[]) =>
    organizationList.map((organization: Organization) => {
      if (organization.subItems) {
        return (
          <TreeNode
            selectable={false}
            className="personItemTreeNode"
            title={
              <div className="personItem">
                {organization.name}{" "}
                {/* {
                        organization.subItems && organization.subItems.length && 
                        <span className={organization.viewSubItems.length !==0 ? 'statistics selectedstatistics' : 'statistics'}>{`${organization.viewSubItems.length}/${organization.personNumber}`}</span>
                    } */}
              </div>
            }
            key={organization.id}
            dataRef={organization}
          >
            {this.renderTreeNodes(organization.subItems)}
          </TreeNode>
        );
      }
      return (
        <TreeNode
          title={organization.name}
          key={organization.id}
          dataRef={organization}
        />
      );
    });
  deepGetCheckedIds = (organizationList: Organization[], alist?) => {
    let list = alist || [];
    for (let item of organizationList) {
      list.push(item.id);
      if (item.subItems && item.subItems.length) {
        list = this.deepGetCheckedIds(item.subItems, list);
      }
    }
    return list;
  };
  removeOrganizationItem = (key, organization: Organization) => {
    let { checkedOrganizationListObj = {} } = this.state;
    let checkedOrganizationList = checkedOrganizationListObj[key];
    checkedOrganizationList.splice(
      checkedOrganizationList.findIndex((item) => item.id === organization.id),
      1
    );
    let checkedIds = this.state.checkedIdsObj[key];
    for (let cid of this.deepGetCheckedIds([organization])) {
      checkedIds.splice(
        checkedIds.findIndex((id) => id === cid),
        1
      );
    }
    this.setState({
      checkedIdsObj: {
        ...this.state.checkedIdsObj,
        [key]: checkedIds,
      },
    });
  };
  onSelect = (selectedKeys, e) => {
    this.setState({
      selectedKeysObj: {
        ...this.state.selectedKeysObj,
        [this.state.tabKey]: selectedKeys,
      },
      selectedOrganizationObj: {
        ...this.state.selectedOrganizationObj,
        [this.state.tabKey]: e.node.props.dataRef,
      },
    });
  };
  onCheckOrganization = (checkedIds, e) => {
    let checkedOrganizationList = e.checkedNodes.map(
      (node) => node.props.dataRef
    );
    let removeIds = [];
    checkedOrganizationList.forEach((org: Organization) => {
      if (
        checkedOrganizationList.some(
          (orgInner: Organization) => orgInner.id == org.parentId
        )
      ) {
        removeIds.push(org.id);
      }
    });
    for (let id of removeIds) {
      checkedOrganizationList.splice(
        checkedOrganizationList.findIndex((org: Organization) => org.id == id),
        1
      );
    }
    this.setState({
      checkedIdsObj: {
        ...this.state.checkedIdsObj,
        [this.state.tabKey]: checkedIds,
      },
      checkedOrganizationListObj: {
        ...this.state.checkedOrganizationListObj,
        [this.state.tabKey]: checkedOrganizationList,
      },
    });
  };
  onTabChange = async (key) => {
    await this.setState({ tabKey: key });
  };
  handleCancel = () => {
    this.setState({
      visible: false,
    });
  };
  getOrganizationList = (data, alist?) => {
    let list = alist || [];
    for (let item of data) {
      list.push(item);
      if (item.subItems && item.subItems.length) {
        list = this.getOrganizationList(item.subItems, list);
      }
    }
    return list;
  };
  onOk = () => {
    let { checkedOrganizationListObj = {} } = this.state;
    let checkedOrganizationList = [];
    for (let tab of this.props.tabs) {
      checkedOrganizationList = [
        ...checkedOrganizationList,
        ...(checkedOrganizationListObj[tab.key] ?? []).map(
          (organization: Organization) => organization
        ),
      ];
    }
    this.props.onChange && this.props.onChange(checkedOrganizationList);
    // if (deep) {
    //     let typeList = this.props.tabs.map(item => (item.key))
    //     let deeplist = this.getOrganizationList(checkedOrganizationList) || []
    //     this.props.onChange &&
    //     this.props.onChange(deeplist.filter(item => ((typeList.indexOf(item.selectType) !== -1))))
    // } else {
    //     this.props.onChange &&
    //     this.props.onChange(checkedOrganizationList)
    // }
    this.setState({
      list: checkedOrganizationList,
      visible: false,
    });
  };
  openModal = async () => {
    await this.setState({ visible: true });
  };
  clickTreeNode = (e, node) => {
    e.preventDefault();
    e.stopPropagation();
    return false;
  };
  async componentDidMount() {
    if (this.props.url && this.props.tabs && this.props.tabs.length) {
      await this.getGroupClassSelectTabTree();
    }
    let { value, tabs } = this.props;
    let list = [];
    let checkedOrganizationListObj = {};
    let checkedIdsObj = {};
    if (value && value.length) {
      if (typeof value[0] === "string") {
        if (JSON.stringify(this.state.treeData) !== "{}") {
          for (let tab of tabs) {
            checkedOrganizationListObj[tab.key] = [];
            checkedIdsObj[tab.key] = [];
          }
          for (let ogztype in this.state.treeData) {
            this.state.treeData[ogztype] &&
              this.state.treeData[ogztype].organizationList &&
              this.state.treeData[ogztype].organizationList.length &&
              this.state.treeData[ogztype].organizationList.map((item) => {
                if (value.indexOf(item.id) !== -1) {
                  list.push(item);
                  checkedOrganizationListObj[ogztype].push(item);
                  checkedIdsObj[ogztype].push(item.id);
                }
              });
          }
        }
      } else {
        for (let tab of this.props.tabs) {
          let checkedIds = this.props.value.filter(
            (org) => org.selectType === tab.key
          );
          checkedIdsObj[tab.key] = checkedIds.map((ids) => ids.id);
          checkedOrganizationListObj[tab.key] = checkedIds;
          list = list.concat(checkedIds);
        }
      }
      this.setState({ list, checkedOrganizationListObj, checkedIdsObj });
    }
    await this.setState({ tabKey: this.props.tabs[0].key });
  }
  async componentWillReceiveProps(newProps) {
    console.log(newProps);
    let { value, tabs } = newProps;
    let list = [];
    let checkedOrganizationListObj = {};
    let checkedIdsObj = {};
    if (value && value.length) {
      if (typeof value[0] === "string") {
        if (JSON.stringify(this.state.treeData) !== "{}") {
          for (let tab of tabs) {
            // let checkedIds = value.filter(
            //     (org) => (org.selectType === tab.key)
            // )
            checkedOrganizationListObj[tab.key] = [];
            checkedIdsObj[tab.key] = [];
          }
          for (let ogztype in this.state.treeData) {
            this.state.treeData[ogztype] &&
              this.state.treeData[ogztype].organizationList &&
              this.state.treeData[ogztype].organizationList.length &&
              this.state.treeData[ogztype].organizationList.map((item) => {
                if (value.indexOf(item.id) !== -1) {
                  list.push(item);
                  checkedOrganizationListObj[ogztype].push(item);
                  checkedIdsObj[ogztype].push(item.id);
                }
              });
          }
        }
      } else {
        for (let tab of newProps.tabs) {
          let checkedIds = newProps.value.filter(
            (org) => org.selectType === tab.key
          );
          checkedIdsObj[tab.key] = checkedIds.map((ids) => ids.id);
          checkedOrganizationListObj[tab.key] = checkedIds;
          list = list.concat(checkedIds);
        }
      }
      this.setState({ list, checkedOrganizationListObj, checkedIdsObj });
    } else {
      this.setState({
        list: [],
        checkedOrganizationListObj: {},
        checkedIdsObj: {},
      });
    }
    // let checkedIdsObj={}
    // let checkedOrganizationListObj={}

    // this.setState({
    //     list: newProps.value,
    //     checkedIdsObj,
    //     checkedOrganizationListObj
    // })
  }

  render() {
    let { disabled = false, children = null } = this.props;
    let {
      checkedOrganizationListObj = {},
      tabKey = "",
      checkedIdsObj,
    } = this.state;
    return (
      <>
        <div onClick={disabled ? () => false : this.openModal}>
          {children ? (
            <div>{children}</div>
          ) : (
            <div
              className={
                disabled
                  ? "group-person-select group-person-select-disabled"
                  : "group-person-select"
              }
            >
              {this.state.list &&
                !!this.state.list.length &&
                this.state.list.map((item) => (
                  <Tag key={item.id}>{item.name}</Tag>
                ))}
              <div className="clear">
                <Icon style={{ fontSize: 18 }} type="usergroup-add" />
              </div>
            </div>
          )}
        </div>
        <Modal
          className="GroupUserSelectModal"
          onCancel={this.handleCancel}
          width={772}
          onOk={this.onOk}
          visible={this.state.visible}
          title="班级选择"
          bodyStyle={{ padding: 0 }}
        >
          <Row>
            <Col span={12}>
              <div className="GroupUserSelectResult">
                {this.props.tabs.map((tab, index) =>
                  (checkedOrganizationListObj[tab.key] ?? []).map(
                    (organization: Organization) => (
                      <Tag
                        className="organizationTag"
                        closable
                        onClose={(e) => {
                          e.preventDefault();
                          this.removeOrganizationItem(tab.key, organization);
                        }}
                        key={organization.id}
                      >
                        {organization.name}
                      </Tag>
                    )
                  )
                )}
              </div>
            </Col>
            <Col span={12}>
              <Card className="GroupUserSelect" bodyStyle={{ padding: 0 }}>
                <Spin
                  spinning={this.state.loading}
                  tip="加载中..."
                  size="large"
                >
                  <Tabs activeKey={tabKey} onChange={this.onTabChange}>
                    {this.props.tabs.map((tab, index) => (
                      <TabPane tab={tab.tab} key={tab.key} forceRender>
                        <div
                          style={{
                            height: 294,
                            position: "relative",
                            overflow: "auto",
                          }}
                        >
                          <Tree
                            // checkStrictly
                            onClick={this.clickTreeNode}
                            checkable
                            onCheck={this.onCheckOrganization}
                            onSelect={this.onSelect}
                            autoExpandParent={this.state.autoExpandParent}
                            checkedKeys={checkedIdsObj[tab.key] ?? []}
                            selectedKeys={
                              this.state.selectedKeysObj[tab.key] ?? []
                            }
                          >
                            {this.renderTreeNodes(
                              this.state.treeData[tab.key]
                                ?.organizationNested ?? []
                            )}
                          </Tree>
                        </div>
                      </TabPane>
                    ))}
                  </Tabs>
                </Spin>
              </Card>
            </Col>
          </Row>
        </Modal>
      </>
    );
  }
}
